
import React from 'react';

const AboutHero: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-teal-50 to-blue-50 py-20 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/1fc5de150f159ff1bc5ce26c38d6d11b.jpg')`
        }}
      />
      <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          About The Simple MD
        </h1>
        <p className="text-xl md:text-2xl text-gray-200">
          Pioneering the future of healthcare in Miami, Florida through innovative virtual care and advanced wellness treatments
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
